// import { Tab } from "@headlessui/react";
// import CarCard from "components/CarCard/CarCard";
// import ExperiencesCard from "components/ExperiencesCard/ExperiencesCard";
// import StayCard from "components/StayCard/StayCard";
// import {
//   DEMO_CAR_LISTINGS,
//   DEMO_EXPERIENCES_LISTINGS,
//   DEMO_STAY_LISTINGS,
// } from "data/listings";
// import React, { Fragment, useState } from "react";
// import ButtonSecondary from "shared/Button/ButtonSecondary";
// import CommonLayout from "./CommonLayout";
import React, { useEffect, Fragment, useState } from "react";
import SectionGridFeatureProperty from "../PageHome/SectionGridFeatureProperty";
import { AuthorType, ListingDataType } from "data/types";
import { Link, useNavigate } from 'react-router-dom';

import ButtonClose from "shared/ButtonClose/ButtonClose";
import { Dialog, Transition } from "@headlessui/react";
// import { PHOTOS } from "containers/ListingDetailPage/listing-stay-detail/constant";
import Avatar from "shared/Avatar/Avatar";
import FiveStartIconForRate from "components/FiveStartIconForRate/FiveStartIconForRate";
import ButtonSquareFull from "shared/Button/ButtonSqareFull";
import Overview from "containers/ListingDetailPage/listing-stay-detail/Overview";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Label from "components/Label/Label";
import Input from "shared/Input/Input";
import Textarea from "shared/Textarea/Textarea";
import FactsFeatures from "containers/ListingDetailPage/listing-stay-detail/FactsFeatures";

const DEMO_LISTINGS: ListingDataType[] = [
    {
      "id": "id1",
      "author":  {
        "id": 1,
        "firstName": "Tony",
        "lastName": "Stark",
        "displayName": "-",
        "email": "tonystark0@gmail.com",
        "avatar": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQmdU20JbK_Fv68F2pkt3ODsftZrI3VnqJwvnG_R06PFfPo19r-HNuSGRWZrFwFYw3is3Q&usqp=CAU",
        "bgImage": "https://images.pexels.com/photos/4064835/pexels-photo-4064835.jpeg?auto=compress&cs=tinysrgb&w=500",
        "count": 40,
        "reviewStart": 4.8,
        "reviewCount": 28,
        "language": "English, Spanish",
        "href": "/author",
        "desc": "There’s no stopping the tech giant. Apple now opens its 100th store in China.There’s no stopping the tech giant.",
        "jobName": "Author Job",
        "company": "Test Company",
        "joindate": "10/10/2023",
        "facebook": "url",
        "twitter": "url",
        "youtube": "url",
        "instagram": "url"
      },
      "date": "May 20, 2021",
      "title": "LUXURIOUS AND MODERN HOUSE FOR SALE",
      "featuredImage": "https://s3.rea.global/img/1208x680-prop/realtor/do/41d52c2d95ca6c168c057842162a9884.jpg",
      "galleryImgs": [
        "https://images.pexels.com/photos/1268871/pexels-photo-1268871.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
        "https://images.pexels.com/photos/1179156/pexels-photo-1179156.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
        "https://images.pexels.com/photos/2506988/pexels-photo-2506988.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
        "https://images.pexels.com/photos/2373201/pexels-photo-2373201.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
      ],
      "viewCount": 602,
      "isLike": false,
      "address": "Punta Cana, Punta Cana, La Altagracia Province",
      "price": "$5,072,588",
      "type": "House",
      "bedrooms": 3,
      "bathrooms": 3,
      "mainFeatures": ["condominium", "Built in 1968", "Forced air, radiator, oil", "2 Garage Spaces", "$2,042 Monthly", "$261 price/sqft"],
      "sqrft":1345,
      "saleOff": "-10% today",
      "isAds": null,
      "isRental": false,
      "overview": {
        "description": "Welcome to 779 prospect Ave PH, the largest penthouse in the Hartford area! This Luxurious 3 beedroom/2.5 bathroom condo has everything you could want or need to entertain! Enjoy over 3,400 sq ft of indoor living space",
        "openDate": "02/02/2023",
        "openHour": "12:00 PM - 2:00 PM",
        "sourceMls": "Smart MLS",
        "mls": "170546053",
        "lastUpdate": "02/02/2023",
        "map": { "lat": -33.8569, "lng": 151.2152 }
      },
      "factsFeatures":{
        "bedrooms": ["Bedrooms: 5","Bathrooms: 4", "Full bathrooms: 3", "1/2 bathrooms: 2"],
        "basements": ["Basement: Heated,Garage Access,Storage Space"],
        "heating": ["Heating features: Forced Air, Radiator, Oil"],
        "cooling": ["Cooling features: Central Air"],
        "appliances": ["Appliances included: Electric Range, Wall Oven, Microwave, Range Hood, Refrigerator, Freezer, Dishwasher, Disposal, Washer, Dryer, Wine Cooler", "Laundry features: Private laundry room in unit, Main Level, Laundry Room"],
        "interior": ["Interior features: Wired for Sound, Elevator, Open Floorplan, Exercise Room, Foyer, Laundry Room"],
        "otherInterior": ["Common walls with other units/homes: End Unit", "Total interior livable area: 3,441 sqft", "Finished area above ground: 3,441", "Total number of fireplaces: 1", "Virtual tour: View virtual"],
        "parking": ["Total spaces: 2", "Parking features: Unit Garage, Assigned, Secured", "Garage spaces: 2"],
        "accesability": ["Accessibility features: Accessible Doors, Accessible Hallway(s)"],
        "property": ["Levels: 1", "Stories: 1", "Exterior features: Awning(s), Garden, Barbecue, Lighting"],
        "lot": ["Lot features: Historic District, Level, Lightly Wooded, Fruit Trees"],
      }
    },
    {
      "id": "id_2",
      "author": {
        "id": 1,
        "firstName": "Alric",
        "lastName": "Truelock",
        "displayName": "Truelock Alric",
        "email": "atruelock0@skype.com",
        "avatar": "https://uifaces.co/our-content/donated/1H_7AxP0.jpg",
        "bgImage": "https://images.pexels.com/photos/4064835/pexels-photo-4064835.jpeg?auto=compress&cs=tinysrgb&w=500",
        "count": 40,
        "reviewStart": 2,
        "reviewCount": 28,
        "href": "/author",
        "language": "English, Spanish",
        "desc": "There’s no stopping the tech giant. Apple now opens its 100th store in China.There’s no stopping the tech giant.",
        "jobName": "Author Job",
        "company": "Test Company",
        "joindate": "10/10/2023",
        "facebook": "url",
        "twitter": "url",
        "youtube": "url",
        "instagram": "url"
      },
      "date": "May 20, 2021",
      "title": "Bell by Greene King Inns ",
      "featuredImage": "https://images.pexels.com/photos/5191371/pexels-photo-5191371.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
      "galleryImgs": [
        "https://images.pexels.com/photos/6434634/pexels-photo-6434634.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
        "https://images.pexels.com/photos/3201735/pexels-photo-3201735.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
        "https://images.pexels.com/photos/4577673/pexels-photo-4577673.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
        "https://images.pexels.com/photos/6474535/pexels-photo-6474535.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
      ],
      "viewCount": 196,
      "isLike": false,
      "address": "32923 Judy Hill",
      "price": "$250",
      "type": "House",
      "bedrooms": 6,
      "bathrooms": 7,
      "mainFeatures": ["condominium", "Built in 1968", "Forced air, radiator, oil", "2 Garage Spaces", "$2,042 Monthly", "$261 price/sqft"],
      "sqrft":130,
      "saleOff": "-10% today",
      "isAds": null,
      "isRental": false,
      "overview": {
        "description": "property desc",
        "openDate": "02/02/2023",
        "openHour": "3pm",
        "sourceMls": "sourceMls",
        "mls": "mls",
        "lastUpdate": "02/02/2023",
        "map": { "lat": 55.2094559, "lng": 61.5594641 }
      },
      "factsFeatures":{
        "bedrooms": ["Bedrooms: 3","Bathrooms: 3", "Full bathrooms: 2", "1/2 bathrooms: 1"],
        "basements": ["Basement: Heated,Garage Access,Storage Space"],
        "heating": ["Heating features: Forced Air, Radiator, Oil"],
        "cooling": ["Cooling features: Central Air"],
        "appliances": ["Appliances included: Electric Range, Wall Oven, Microwave, Range Hood, Refrigerator, Freezer, Dishwasher, Disposal, Washer, Dryer, Wine Cooler", "Laundry features: Private laundry room in unit, Main Level, Laundry Room"],
        "interior": ["Interior features: Wired for Sound, Elevator, Open Floorplan, Exercise Room, Foyer, Laundry Room"],
        "otherInterior": ["Common walls with other units/homes: End Unit", "Total interior livable area: 3,441 sqft", "Finished area above ground: 3,441", "Total number of fireplaces: 1", "Virtual tour: View virtual"],
        "parking": ["Total spaces: 2", "Parking features: Unit Garage, Assigned, Secured", "Garage spaces: 2"],
        "accesability": ["Accessibility features: Accessible Doors, Accessible Hallway(s)"],
        "property": ["Levels: 1", "Stories: 1", "Exterior features: Awning(s), Garden, Barbecue, Lighting"],
        "lot": ["Lot features: Historic District, Level, Lightly Wooded, Fruit Trees"],
      } 
    },
    {
      "id": "id_3",
      "author": {
        "id": 2,
        "firstName": "Chariot",
        "lastName": "Birrell",
        "displayName": "Birrell Chariot",
        "email": "cbirrell1@google.com.hk",
        "avatar": "https://uifaces.co/our-content/donated/gPZwCbdS.jpg",
        "count": 113,
        "reviewStart": 3.3,
        "reviewCount": 28,
        "href": "/author",
        "language": "English, Spanish",
        "desc": "There’s no stopping the tech giant. Apple now opens its 100th store in China.There’s no stopping the tech giant.",
        "jobName": "Author Job",
        "bgImage": "https://images.pexels.com/photos/5799379/pexels-photo-5799379.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
        "company": "Test Company",
        "joindate": "10/10/2023",
        "facebook": "url",
        "twitter": "url",
        "youtube": "url",
        "instagram": "url"
      },
      "date": "May 20, 2021",
      "title": "Half Moon, Sherborne by Marston's Inns ",
      "featuredImage": "https://images.pexels.com/photos/5191371/pexels-photo-5191371.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
      "galleryImgs": [
        "https://images.pexels.com/photos/4186560/pexels-photo-4186560.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
        "https://images.pexels.com/photos/2404422/pexels-photo-2404422.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
        "https://images.pexels.com/photos/2677398/pexels-photo-2677398.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
        "https://images.pexels.com/photos/756078/pexels-photo-756078.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
      ],
      "viewCount": 843,
      "isLike": true,
      "address": "6731 Killdeer Park",
      "price": "$278",
      "type": "House",
      "bedrooms": 9,
      "bathrooms": 8,
      "mainFeatures": ["condominium", "Built in 1968", "Forced air, radiator, oil", "2 Garage Spaces", "$2,042 Monthly", "$261 price/sqft"],
      "sqrft":100,
      "saleOff": null,
      "isAds": null,
      "isRental": false,
      "overview": {
        "description": "property desc",
        "openDate": "02/02/2023",
        "openHour": "3pm",
        "sourceMls": "sourceMls",
        "mls": "mls",
        "lastUpdate": "02/02/2023",
        "map": { "lat": 55.2094559, "lng": 61.5594641 }
      },
      "factsFeatures":{
        "bedrooms": ["Bedrooms: 3","Bathrooms: 3", "Full bathrooms: 2", "1/2 bathrooms: 1"],
        "basements": ["Basement: Heated,Garage Access,Storage Space"],
        "heating": ["Heating features: Forced Air, Radiator, Oil"],
        "cooling": ["Cooling features: Central Air"],
        "appliances": ["Appliances included: Electric Range, Wall Oven, Microwave, Range Hood, Refrigerator, Freezer, Dishwasher, Disposal, Washer, Dryer, Wine Cooler", "Laundry features: Private laundry room in unit, Main Level, Laundry Room"],
        "interior": ["Interior features: Wired for Sound, Elevator, Open Floorplan, Exercise Room, Foyer, Laundry Room"],
        "otherInterior": ["Common walls with other units/homes: End Unit", "Total interior livable area: 3,441 sqft", "Finished area above ground: 3,441", "Total number of fireplaces: 1", "Virtual tour: View virtual"],
        "parking": ["Total spaces: 2", "Parking features: Unit Garage, Assigned, Secured", "Garage spaces: 2"],
        "accesability": ["Accessibility features: Accessible Doors, Accessible Hallway(s)"],
        "property": ["Levels: 1", "Stories: 1", "Exterior features: Awning(s), Garden, Barbecue, Lighting"],
        "lot": ["Lot features: Historic District, Level, Lightly Wooded, Fruit Trees"],
      }
    },
    {
      "id": "id_4",
      "author": {
        "id": 3,
        "firstName": "Nathanil",
        "lastName": "Foulcher",
        "displayName": "Foulcher Nathanil",
        "email": "nfoulcher2@google.com.br",
        "avatar": "https://uifaces.co/our-content/donated/3799Ffxy.jpeg",
        "count": 43,
        "reviewStart": 4.2,
        "reviewCount": 28,
        "language": "English, Spanish",
        "href": "/author",
        "desc": "There’s no stopping the tech giant. Apple now opens its 100th store in China.There’s no stopping the tech giant.",
        "jobName": "Author Job",
        "bgImage": "https://images.pexels.com/photos/1001990/pexels-photo-1001990.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
        "company": "Test Company",
        "joindate": "10/10/2023",
        "facebook": "url",
        "twitter": "url",
        "youtube": "url",
        "instagram": "url"
      },
      "date": "May 20, 2021",
      "title": "White Horse Hotel by Greene King Inns ",
      "featuredImage": "https://images.pexels.com/photos/5191371/pexels-photo-5191371.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
      "galleryImgs": [
        "https://images.pexels.com/photos/2290738/pexels-photo-2290738.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
        "https://images.pexels.com/photos/751268/pexels-photo-751268.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
        "https://images.pexels.com/photos/3201922/pexels-photo-3201922.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
        "https://images.pexels.com/photos/2404422/pexels-photo-2404422.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
      ],
      "viewCount": 91,
      "isLike": false,
      "address": "35 Sherman Park",
      "price": "$40",
      "type": "House",
      "bedrooms": 7,
      "bathrooms": 5,
      "mainFeatures": ["condominium", "Built in 1968", "Forced air, radiator, oil", "2 Garage Spaces", "$2,042 Monthly", "$261 price/sqft"],
      "sqrft":110,
      "saleOff": null,
      "isAds": null,
      "isRental": false,
      "overview": {
        "description": "property desc",
        "openDate": "02/02/2023",
        "openHour": "3pm",
        "sourceMls": "sourceMls",
        "mls": "mls",
        "lastUpdate": "02/02/2023",
        "map": { "lat": 55.2094559, "lng": 61.5594641 }
      },
      "factsFeatures":{
        "bedrooms": ["Bedrooms: 3","Bathrooms: 3", "Full bathrooms: 2", "1/2 bathrooms: 1"],
        "basements": ["Basement: Heated,Garage Access,Storage Space"],
        "heating": ["Heating features: Forced Air, Radiator, Oil"],
        "cooling": ["Cooling features: Central Air"],
        "appliances": ["Appliances included: Electric Range, Wall Oven, Microwave, Range Hood, Refrigerator, Freezer, Dishwasher, Disposal, Washer, Dryer, Wine Cooler", "Laundry features: Private laundry room in unit, Main Level, Laundry Room"],
        "interior": ["Interior features: Wired for Sound, Elevator, Open Floorplan, Exercise Room, Foyer, Laundry Room"],
        "otherInterior": ["Common walls with other units/homes: End Unit", "Total interior livable area: 3,441 sqft", "Finished area above ground: 3,441", "Total number of fireplaces: 1", "Virtual tour: View virtual"],
        "parking": ["Total spaces: 2", "Parking features: Unit Garage, Assigned, Secured", "Garage spaces: 2"],
        "accesability": ["Accessibility features: Accessible Doors, Accessible Hallway(s)"],
        "property": ["Levels: 1", "Stories: 1", "Exterior features: Awning(s), Garden, Barbecue, Lighting"],
        "lot": ["Lot features: Historic District, Level, Lightly Wooded, Fruit Trees"],
      }
    },
    {
      "id": "id_5",
      "author": {
        "id": 3,
        "firstName": "Nathanil",
        "lastName": "Foulcher",
        "displayName": "Foulcher Nathanil",
        "email": "nfoulcher2@google.com.br",
        "avatar": "https://uifaces.co/our-content/donated/3799Ffxy.jpeg",
        "count": 43,
        "reviewStart": 1.8,
        "reviewCount": 28,
        "href": "/author",
        "language": "English, Spanish",
        "desc": "There’s no stopping the tech giant. Apple now opens its 100th store in China.There’s no stopping the tech giant.",
        "jobName": "Author Job",
        "bgImage": "https://images.pexels.com/photos/1001990/pexels-photo-1001990.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
        "company": "Test Company",
        "joindate": "10/10/2023",
        "facebook": "url",
        "twitter": "url",
        "youtube": "url",
        "instagram": "url"
      },
      "date": "May 20, 2021",
      "title": "Ship and Castle Hotel ",
      "featuredImage": "https://images.pexels.com/photos/5191371/pexels-photo-5191371.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
      "galleryImgs": [
        "https://images.pexels.com/photos/261327/pexels-photo-261327.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
        "https://images.pexels.com/photos/2079452/pexels-photo-2079452.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
        "https://images.pexels.com/photos/261410/pexels-photo-261410.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
        "https://images.pexels.com/photos/2983472/pexels-photo-2983472.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
      ],
      "viewCount": 574,
      "isLike": false,
      "address": "3 Crest Line Park",
      "price": "$147",
      "type": "House",
      "bedrooms": 3,
      "bathrooms": 2,
      "mainFeatures": ["Condominium", "Built in 1968", "Forced air, radiator, oil", "2 Garage Spaces", "$2,042 Monthly", "$261 price/sqft"],
      "sqrft":170,
      "saleOff": null,
      "isAds": null,
      "isRental": false,
      "overview": {
        "description": "property desc",
        "openDate": "02/02/2023",
        "openHour": "3pm",
        "sourceMls": "sourceMls",
        "mls": "mls",
        "lastUpdate": "02/02/2023",
        "map": { "lat": 55.2094559, "lng": 61.5594641 }
      },
      "factsFeatures":{
        "bedrooms": ["Bedrooms: 3","Bathrooms: 3", "Full bathrooms: 2", "1/2 bathrooms: 1"],
        "basements": ["Basement: Heated,Garage Access,Storage Space"],
        "heating": ["Heating features: Forced Air, Radiator, Oil"],
        "cooling": ["Cooling features: Central Air"],
        "appliances": ["Appliances included: Electric Range, Wall Oven, Microwave, Range Hood, Refrigerator, Freezer, Dishwasher, Disposal, Washer, Dryer, Wine Cooler", "Laundry features: Private laundry room in unit, Main Level, Laundry Room"],
        "interior": ["Interior features: Wired for Sound, Elevator, Open Floorplan, Exercise Room, Foyer, Laundry Room"],
        "otherInterior": ["Common walls with other units/homes: End Unit", "Total interior livable area: 3,441 sqft", "Finished area above ground: 3,441", "Total number of fireplaces: 1", "Virtual tour: View virtual"],
        "parking": ["Total spaces: 2", "Parking features: Unit Garage, Assigned, Secured", "Garage spaces: 2"],
        "accesability": ["Accessibility features: Accessible Doors, Accessible Hallway(s)"],
        "property": ["Levels: 1", "Stories: 1", "Exterior features: Awning(s), Garden, Barbecue, Lighting"],
        "lot": ["Lot features: Historic District, Level, Lightly Wooded, Fruit Trees"],
      }
    },
    {
      "id": "id_6",
      "author":  {
        "id": 4,
        "firstName": "Agnes",
        "lastName": "Falconar",
        "displayName": "Falconar Agnes",
        "email": "afalconar3@google.ru",
        "avatar": "https://uifaces.co/our-content/donated/KtCFjlD4.jpg",
        "count": 36,
        "reviewStart": 2.8,
        "reviewCount": 28,
        "language": "English, Spanish",
        "href": "/author",
        "desc": "There’s no stopping the tech giant. Apple now opens its 100th store in China.There’s no stopping the tech giant.",
        "jobName": "Author Job",
        "bgImage": "https://images.pexels.com/photos/2394446/pexels-photo-2394446.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
        "company": "Test Company",
        "joindate": "10/10/2023",
        "facebook": "url",
        "twitter": "url",
        "youtube": "url",
        "instagram": "url"
      },
      "date": "May 20, 2021",
      "title": "The Windmill Family & Commercial Hotel ",
      "featuredImage": "https://images.pexels.com/photos/5191371/pexels-photo-5191371.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
      "galleryImgs": [
        "https://images.pexels.com/photos/2373201/pexels-photo-2373201.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
        "https://images.pexels.com/photos/2736187/pexels-photo-2736187.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
        "https://images.pexels.com/photos/6900098/pexels-photo-6900098.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
        "https://images.pexels.com/photos/1371313/pexels-photo-1371313.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
      ],
      "viewCount": 210,
      "isLike": true,
      "address": "55974 Waxwing Junction",
      "price": "$90",
      "type": "House",
      "bedrooms": 7,
      "bathrooms": 7,
      "mainFeatures": ["condominium", "Built in 1968", "Forced air, radiator, oil", "2 Garage Spaces", "$2,042 Monthly", "$261 price/sqft"],
      "sqrft":180,
      "saleOff": null,
      "isAds": null,
      "isRental": false,
      "overview": {
        "description": "property desc",
        "openDate": "02/02/2023",
        "openHour": "3pm",
        "sourceMls": "sourceMls",
        "mls": "mls",
        "lastUpdate": "02/02/2023",
        "map": { "lat": 55.2094559, "lng": 61.5594641 }
      },
      "factsFeatures":{
        "bedrooms": ["Bedrooms: 3","Bathrooms: 3", "Full bathrooms: 2", "1/2 bathrooms: 1"],
        "basements": ["Basement: Heated,Garage Access,Storage Space"],
        "heating": ["Heating features: Forced Air, Radiator, Oil"],
        "cooling": ["Cooling features: Central Air"],
        "appliances": ["Appliances included: Electric Range, Wall Oven, Microwave, Range Hood, Refrigerator, Freezer, Dishwasher, Disposal, Washer, Dryer, Wine Cooler", "Laundry features: Private laundry room in unit, Main Level, Laundry Room"],
        "interior": ["Interior features: Wired for Sound, Elevator, Open Floorplan, Exercise Room, Foyer, Laundry Room"],
        "otherInterior": ["Common walls with other units/homes: End Unit", "Total interior livable area: 3,441 sqft", "Finished area above ground: 3,441", "Total number of fireplaces: 1", "Virtual tour: View virtual"],
        "parking": ["Total spaces: 2", "Parking features: Unit Garage, Assigned, Secured", "Garage spaces: 2"],
        "accesability": ["Accessibility features: Accessible Doors, Accessible Hallway(s)"],
        "property": ["Levels: 1", "Stories: 1", "Exterior features: Awning(s), Garden, Barbecue, Lighting"],
        "lot": ["Lot features: Historic District, Level, Lightly Wooded, Fruit Trees"],
      }
    }
   ];

const AccountSavelists2 = () => {
  let [isOpenModalDetails, setIsOpenModalDetails] = useState(false);
  let [isOpenModalTour, setIsOpenModalTour] = useState(false);
  let [isOpenModalContact, setIsOpenModalContact] = useState(false);
  let [isTypePerson, setIsTypePerson] = useState(true);
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [modalPropertyData, setModalPropertyData] = useState<ListingDataType>();
  const [author, setAuthor] = useState<AuthorType>();
  const navigate = useNavigate();

  function openModalDetails() {
    setIsOpenModalDetails(true);
  }
  
  function closeModalDetails() {
    setIsOpenModalDetails(false);
  }

  function closeModalTour() {
    setIsOpenModalTour(false);
  }

  function changeTypePerson() {
    setIsTypePerson(true);
  }

  function changeTypeVideo() {
    setIsTypePerson(false);
  }

  function openModalTour() {
    setIsOpenModalTour(true);
  }

  function openModalContact() {
    setIsOpenModalContact(true);
  }

  function closeModalContact() {
    setIsOpenModalContact(false);
  }
  const HandleButtonClick = (info: ListingDataType ) => {
   setModalPropertyData(info);
   setAuthor(info.author);
   const smallScreenBreakpoint = 768; 
   if (window.innerWidth <= smallScreenBreakpoint) {
      navigate('/mobile-detail', { state: info });
   } else {
     openModalDetails();
   }
  };
 
  const renderGallery = () => {
    return (
        <div className="flex flex-col ">
           
            <div className="relative flex-col w-full h-[400px] rounded-sm overflow-hidden cursor-pointer bg-[white] mb-[2px]">
                <img
                  className="absolute inset-0 object-cover rounded-sm sm:rounded-sm w-full h-full"
                  src={modalPropertyData?.featuredImage}
                  alt=""
                  sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 50vw"
                />
            {/* <div className="absolute inset-0 bg-neutral-900 bg-opacity-20 opacity-0 hover:opacity-100 transition-opacity"></div> */}
          </div>
        {/* <div className=" grid grid-cols-2 gap-[2px] scroll-top-0" style="grid-auto-rows: 100px;"> */}
        <div className="grid grid-cols-2 gap-[2px] scroll-top-0 h-[400px]">

          {modalPropertyData?.galleryImgs?.map((item, index) => (
            <div
              key={index}
              className={`relative rounded-sm overflow-hidden ${
                index >= 3 ? "hidden sm:block" : ""
              }`}
            >
              <div className="aspect-w-4 aspect-h-3 sm:aspect-w-6 sm:aspect-h-5">
                <img
                  className="absolute inset-0 object-cover rounded-sm  w-full h-full"
                  src={item || ""}
                  alt=""
                  sizes="400px"
                />
              </div>

              {/* OVERLAY */}
              <div
                className="absolute inset-0 bg-neutral-900 bg-opacity-20 opacity-0 hover:opacity-100 transition-opacity cursor-pointer"
                
              />
            </div>
          ))}


          {/* <button
            className="absolute hidden md:flex md:items-center md:justify-center left-3 bottom-3 px-4 py-2 rounded-xl bg-neutral-100 text-neutral-500 hover:bg-neutral-200 z-10"
            
          >
            <Squares2X2Icon className="w-5 h-5" />
            <span className="ml-2 text-neutral-800 text-sm font-medium">
              Show all photos
            </span>
          </button> */}
        </div>
       </div>
        );
        };

        const renderTienIch = () => {
          return (
            <div className="inline-grid grid-cols-3 gap-2 py-[10px]">
              <div className="flex items-center space-x-2">
                <span className="hidden sm:inline-block">
                  <i className="las la-bed text-lg"></i>
                </span>
                <span className="text-xs text-neutral-500 dark:text-neutral-400">
                  {modalPropertyData?.bedrooms} beds
                </span>
              </div>
      
              {/* ---- */}
              <div className="flex items-center space-x-2">
                <span className="hidden sm:inline-block">
                  <i className="las la-bath text-lg"></i>
                </span>
                <span className="text-xs text-neutral-500 dark:text-neutral-400">
                {modalPropertyData?.bathrooms} baths
                </span>
              </div>
      
              {/* ---- */}
              <div className="flex items-center space-x-2">
                <span className="hidden sm:inline-block">
                  <i className="las la-expand-arrows-alt text-lg"></i>
                </span>
                <span className="text-xs text-neutral-500 dark:text-neutral-400">
                {modalPropertyData?.sqrft} Sq. Fit
                </span>
              </div>
            </div>
          );
        };

        const renderMainFeatures = (features: string[] | undefined) => {
          // const features = propertyObject.mainFeatures
          if (!features) {
            return null; // or <div>No data available</div> or any other alternative
          }
          return (
            <div className="flex flex-col">
              {features.map((data, index) => (
                <div key={index} className="flex flex-row">
                  {index % 2 === 0 && (
                    <>
                      <div className="flex-col prose sm:prose w-1/2">
                        <ul className="text-xs text-left">
                          <li>{data}</li>
                        </ul>
                      </div>
                      {features[index + 1] && (
                        <div className="flex-col prose sm:prose w-1/2">
                          <ul className="text-xs text-left">
                            <li>{features[index + 1]}</li>
                          </ul>
                        </div>
                      )}
                    </>
                  )}
                </div>
              ))}
            </div>
          );
        };

        const renderSidebar = () => {
          return (
            <div className="py-[20px] ">
              
              <div className="flex justify-between pb-[10px] ">
                <span className="text-3xl ">
                 
                {modalPropertyData?.price}
                </span>
              </div>
              <div className="flex flex-col ">
                <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
                  {renderTienIch()}
                </div>
                <div className="flex flex-col  pt-[5px] pb-[20px]">
              {/* {isAds && <Badge name="ADS" color="green" />} */}
              <h2 className="flex justify-left text-sm font-medium capitalize">
                <span className="line-clamp-2">{modalPropertyData?.title}</span>
              </h2>
              <div className="flex justify-left text-sm font-light pt-[5px]">
                {modalPropertyData?.address}
              </div>
            </div>
                 {/* host */}
                  <div className="flex items-center space-x-4 pt-[20px] pl-[35px]">
                        <Avatar
                          hasChecked
                          hasCheckedClass="w-4 h-4 -top-0.5 right-0.5"
                          sizeClass="h-20 w-20"
                          radius="rounded-full"
                          imgUrl={modalPropertyData?.author?.avatar}
                        />
                        <div >
                            {/* <a className=" text-md font-medium flex justify-left hover:no-underline" href="/author">
                            {modalPropertyData?.author.firstName} {modalPropertyData?.author.lastName}
                            </a> */}
                            <Link className=" text-md font-medium flex justify-left" to="/author" state= {author}>
                                   {modalPropertyData?.author?.firstName} {modalPropertyData?.author?.lastName}
                                </Link>

                            <div className=" flex items-center text-sm text-neutral-500 dark:text-neutral-400">
                              {/* <StartRating /> */}
                              <FiveStartIconForRate iconClass="w-4 h-4 " className="space-x-0.5" defaultPoint={modalPropertyData?.author?.reviewStart}/>
                              <span className="mx-2">·</span>
                            </div>
                        </div>
                        
                  </div>
                  <div className="flex flex-row justify-left  pt-[30px]">
                      <div className="flex-col pr-[20px]">
                              <ButtonSquareFull onClick={openModalTour} className="bg-[#16385D] text-sm font-medium text-[white] px-[22px]"
                                size="h-11" >
                            Request a Tour
                            </ButtonSquareFull>
                      </div>
                         <div className="flex-col">
                            <ButtonSquareFull onClick={openModalContact} className="bg-[white] border border-[#16385D] text-sm font-medium text-[#16385D] px-[22px]"
                                size="h-11" >
                            Contact Agent
                            </ButtonSquareFull>
                         </div>  
                         {renderModalTour()}  
                         {renderModalContact()}  
                   </div>
                   <div className="pt-[30px] ">
                   {renderMainFeatures(modalPropertyData?.mainFeatures)}
                   </div>
                     
                        

                     <div className="grid grid-cols-1 gap-3 mt-[35px] pb-[20px] ">
                        <div className="   rounded-lg bg-[#E3F3FF] ">
                          <Overview className="flex flex-col " overview={modalPropertyData?.overview} author={modalPropertyData?.author} />
                        </div>
                        <div className="  rounded-lg bg-[#E3F3FF]">
                          <FactsFeatures className="flex flex-col" facts={modalPropertyData?.factsFeatures}/>
                          {/* <Overview className="flex flex-col " uniqueClassName="PageHome2_s2"/> */}
                        </div>
                        <div className=" rounded-lg bg-[#E3F3FF]">
                          {/* <ContactAgent className="flex " /> */}
                          {/* <Overview className="flex flex-col " uniqueClassName="PageHome2_s2" /> */}
                        </div>
                        {/* {DEMO_DATA.map((item, index) => (
                          <FlightCard defaultOpen={!index} key={index} data={item} />
                        ))} */}
                    </div>
                  </div>
              {/* </div> */}
      
              {/* SUBMIT */}
              {/* <ButtonPrimary href={"/checkout"}>Reserve</ButtonPrimary> */}
            </div>
          );
        };


        const renderModalTour = () => {
          return (
            <Transition appear show={isOpenModalTour} as={Fragment}>
              <Dialog
                as="div"
                className="fixed inset-0 z-50 overflow-y-auto"
                onClose={closeModalTour}
              >
                <div className="min-h-screen px-4 text-center">
                  <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                  >
                    <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-40" />
                  </Transition.Child>
      
                  {/* This element is to trick the browser into centering the modal contents. */}
                  <span
                    className="inline-block h-screen align-middle"
                    aria-hidden="true"
                  >
                    &#8203;
                  </span>
                  <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0 scale-95"
                    enterTo="opacity-100 scale-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100 scale-100"
                    leaveTo="opacity-0 scale-95"
                  >
                    <div className="inline-block py-8 h-[600px] w-full max-w-sm">
                      <div className="inline-flex pb-2 flex-col w-full text-left align-middle transition-all transform overflow-hidden rounded-2xl bg-white shadow-xl h-full">
                        <div className="relative flex-shrink-0 px-6 py-4 border-b border-neutral-200 dark:border-neutral-800 text-center">
                          <h3
                            className="text-md font-medium leading-6 text-gray-900"
                            id="headlessui-dialog-title-70"
                          >
                            Take a tour with a buyer's agent
                          </h3>
                          <span className="absolute left-3 top-3">
                            <ButtonClose onClick={closeModalTour} />
                          </span>
                        </div>
                        {/* <div className="px-8 overflow-auto text-neutral-700 dark:text-neutral-300 divide-y divide-neutral-200"> */}
                        <div className=" px-8  text-neutral-700  ">
                        <label className="block py-[15px]">
                           <Label>Tour type</Label>
                             <div className="flex justify-center w-full">
                                  <div className="inline-flex  rounded-lg py-[3px]" role="group">
                                    <button onClick={changeTypePerson} type="button" className={`w-[160px] py-3 text-xs font-medium  rounded-l-xl  ${isTypePerson ? "text-white bg-[#1A4676] " : "text-[#1A4676] bg-white border border-[#1A4676]"}`}>
                                      in-person
                                    </button>
                                    <button onClick={changeTypeVideo} type="button" className={`w-[160px] py-3 text-xs font-medium  rounded-r-xl ${isTypePerson ? "text-[#1A4676] bg-white border border-[#1A4676] " : "text-white bg-[#1A4676]"}`}>
                                      Video chat
                                    </button>
                                  </div>
                              </div>
                           </label> 
                              <div className="w-full">
                                 <label className="block">
                                    <Label>Tour date</Label>
                                         <DatePicker className="rounded-md w-[320px]"
                                          selected={startDate}
                                          onChange={(date) => setStartDate(date)}
                                          minDate={new Date()}
                                          showTimeSelect
                                          timeFormat="HH:mm"
                                          timeIntervals={30}
                                          timeCaption="time"
                                          dateFormat="MMMM d, yyyy h:mm aa"
                                          placeholderText="Select date and time"
                                        />
                                   </label>                                        
                              </div>
                              <div>
                                    <form className="grid grid-cols-1 gap-6" >
                                      <label className="block pt-[20px]">
                                        <Label>Full name</Label>

                                        <Input
                                          placeholder="Type your full name"
                                          type="text"
                                          className="mt-1 rounded-md"
                                        />
                                      </label>
                                      <label className="block">
                                        <Label>Email address</Label>

                                        <Input
                                          type="email"
                                          placeholder="example@example.com"
                                          className="mt-1 rounded-md"
                                        />
                                      </label>
                                      {/* <label className="block">
                                        <Label>Message</Label>

                                        <Textarea className="mt-1" rows={6} />
                                      </label> */}
                                      <div>
                                        <button className="p-3 text-white font-medium  rounded-lg w-full bg-[#00D3DB]" type="submit">Request this time</button>
                                      </div>
                                    </form>
                               </div>
                        </div>
                      </div>
                    </div>
                  </Transition.Child>
                </div>
              </Dialog>
            </Transition>
          );
        };  
        
        const renderModalContact = () => {
          return (
            <Transition appear show={isOpenModalContact} as={Fragment}>
              <Dialog
                as="div"
                className="fixed inset-0 z-50 overflow-y-auto"
                onClose={closeModalContact}
              >
                <div className="min-h-screen px-4 text-center">
                  <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                  >
                    <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-40" />
                  </Transition.Child>
      
                  {/* This element is to trick the browser into centering the modal contents. */}
                  <span
                    className="inline-block h-screen align-middle"
                    aria-hidden="true"
                  >
                    &#8203;
                  </span>
                  <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0 scale-95"
                    enterTo="opacity-100 scale-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100 scale-100"
                    leaveTo="opacity-0 scale-95"
                  >
                    <div className="inline-block py-8 h-[600px] w-full max-w-sm">
                      <div className="inline-flex pb-2 flex-col w-full text-left align-middle transition-all transform overflow-hidden rounded-2xl bg-white shadow-xl h-full">
                        <div className="relative flex-shrink-0 px-6 py-4 border-b border-neutral-200 dark:border-neutral-800 text-center">
                          <h3
                            className="text-md font-medium leading-6 text-gray-900"
                            id="headlessui-dialog-title-70"
                          >
                            Contact buyer agent
                          </h3>
                          <span className="absolute left-3 top-3">
                            <ButtonClose onClick={closeModalContact} />
                          </span>
                        </div>
                        {/* <div className="px-8 overflow-auto text-neutral-700 dark:text-neutral-300 divide-y divide-neutral-200"> */}
                        <div className=" px-8  text-neutral-700  ">
                              <div>
                                    <form className="grid grid-cols-1 gap-6" >
                                      <label className="block pt-[20px]">
                                        <Label>Full name</Label>

                                        <Input
                                          placeholder="Type your full name"
                                          type="text"
                                          className="mt-1 rounded-md"
                                        />
                                      </label>
                                      <label className="block">
                                        <Label>Email address</Label>

                                        <Input
                                          type="email"
                                          placeholder="example@example.com"
                                          className="mt-1 rounded-md"
                                        />
                                      </label>
                                      <label className="block">
                                        <Label>Message</Label>

                                        <Textarea className="mt-1" rows={6} />
                                      </label>
                                      <div>
                                        <button className="p-3 text-white font-medium  rounded-lg w-full bg-[#00D3DB]" type="submit">Send</button>
                                      </div>
                                    </form>
                               </div>
                        </div>
                      </div>
                    </div>
                  </Transition.Child>
                </div>
              </Dialog>
            </Transition>
          );
        };       

  const renderModalDetails = () => {
    return (
      <Transition appear show={isOpenModalDetails} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-50 overflow-y-auto"
          onClose={closeModalDetails}
        >
          <div className=" text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-60 backdrop-blur-xl backdrop-contrast-125 " />
            </Transition.Child>

            {/* This element is to trick the browser into centering the modal contents. */}
            <span
              className="inline-block h-screen align-middle"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <div className="inline-block  w-full max-w-6xl h-screen">
                <div className="  flex flex-col lg:flex-row  h-full w-full overflow-hidden">
                  <div className="relative flex-col lg:w-3/5 w-full  space-y-8 lg:space-y-10 overflow-y-auto scroll-top-0 bg-[white]">
                  {renderGallery()}
                    
                  </div>
                 
                  <div className="flex-col bg-[white] lg:w-2/5 w-full ">
                      <div className=" h-[30px] bg-[#D9EEFF57]">
                    
                      </div>
                      <div className=" mx-[20px] h-full overflow-y-auto ">
                         {renderSidebar()}

                      </div>   
                  </div>
                 
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>
    );
  };

  return (
    <div className="nc-PageWishList relative overflow-hidden">
    
      <div className="container relative  ">
       <div className="relative py-8 ">
          {/* <BackgroundSection className = "bg-neutral-100  w-screen"/> */}
          <SectionGridFeatureProperty featuredListings={DEMO_LISTINGS} propertyDetail={HandleButtonClick}/>
          {renderModalDetails()}
        </div>
    </div>
  </div>
    
  );
};

export default AccountSavelists2;